import React from 'react';
export function PainSection() {
  return <section className="py-20 bg-white border-b border-crema-darker" data-id="element-171">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl" data-id="element-172">
        {/* Emotional Hook */}
        <div className="mb-16" data-id="element-173">
          <div className="bg-crema-dark/30 border-l-4 border-oliva p-6 sm:p-8 rounded-r-lg mb-8" data-id="element-174">
            <p className="font-heading text-2xl sm:text-3xl text-oliva-dark italic font-bold" data-id="element-175">
              "No estaba enferma. Pero tampoco era yo."
            </p>
          </div>

          <div className="space-y-6 text-lg text-marron leading-relaxed" data-id="element-176">
            <p data-id="element-177">
              Esa sensación de levantarte cansada después de 8 horas de sueño.
            </p>
            <p data-id="element-178">
              Ese dolor en las rodillas o en la espalda que "no es para tanto"
              pero nunca se va del todo.
            </p>
            <p data-id="element-179">
              Esa niebla mental que te hace olvidar palabras, perder el hilo de
              la conversación, o sentir que tu cabeza no arranca hasta el
              mediodía.
            </p>
            <p data-id="element-180">
              Si tenés más de 45 años y te identificás con alguna de estas
              señales, no estás sola. Y lo más importante:
            </p>
            <p className="text-xl font-bold text-terracota" data-id="element-181">
              No es la edad. Es la inflamación silenciosa que nadie te está
              tratando.
            </p>
          </div>
        </div>
      </div>
    </section>;
}